module.exports = __webpack_public_path__ + "static/ClickedCommon-005a6f160cccb319e48503f5cb686dc2.png";